export default {
  submitButton: {
    id: 'checkout_step_addresses_submit_button',
    defaultMessage: 'Next',
  },
  nextErrorToastTitle: {
    id: 'checkout_step_next_error_toast_title',
    defaultMessage: 'Unable to continue',
  },
  nextErrorToastDescription: {
    id: 'checkout_step_next_error_toast_description',
    defaultMessage:
      'Please save your address changes before continuing to payment.',
  },
}
